import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import "./styles.css";
import { announceOfflineStatus, confirmActiveOfflineWorker } from "./lib/offline";

registerSW({
  immediate: true,
  onOfflineReady: () => announceOfflineStatus("ready"),
  onRegisteredSW: () => void confirmActiveOfflineWorker(),
  onRegisterError: () => announceOfflineStatus("error"),
});

createRoot(document.getElementById("root")!).render(
  <StrictMode><App /></StrictMode>,
);
